import { render, staticRenderFns } from "./TipModal.vue?vue&type=template&id=5c924180&"
import script from "./TipModal.vue?vue&type=script&lang=js&"
export * from "./TipModal.vue?vue&type=script&lang=js&"
import style0 from "./TipModal.vue?vue&type=style&index=0&id=5c924180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports